import { setCompassConfig } from '@scale/compass-ui/config';
import { GenAIOpsHubPaths } from 'react-scale/corp/views/CorpProjectGroupManager/constants';
import { genAICardUIs } from 'react-scale/corp/views/DataCompassCardsV2/genAICardUIs';
import getUserQueryOptions from './userInfo';
import { handleGenericError } from './handleGenericError';
import logger from 'react-scale/lib/logging';
import { CompassRoutes } from '@scale/compass-ui/constants/nav';
import useSearchParams from './hooks/useSearchParams';
import {
  faBan,
  faBolt,
  faCheckCircle,
  faClipboardCheck,
  faFileAlt,
  faTags,
  faUserGraduate,
} from '@fortawesome/pro-regular-svg-icons';

setCompassConfig({
  workflowsUrl: `/corp${GenAIOpsHubPaths.Compass}${CompassRoutes.Workflows}`,
  playgroundUrl: `/corp${GenAIOpsHubPaths.Compass}${CompassRoutes.Playground}`,
  searchUrl: `/corp${GenAIOpsHubPaths.OpsSearchBase}`,
  cardUIs: genAICardUIs,
  getUserQueryOptions,
  logger,
  errorHandler: handleGenericError,
  useSearchParams,
  productCopy: {
    workflowsPageSubtitle: 'View and manage your Workflows.',
    userGuideUrl:
      'https://scale.atlassian.net/wiki/spaces/EPD/pages/1485963374/GenAI+Compass+User+Guide+go+compass',
  },
  starterTemplates: [
    {
      icon: faClipboardCheck,
      label: 'Clipboard Check',
      workflowName: 'LLM evals to audit tasks',
      iconBackgroundColor: 'bg-success-a2',
      iconColor: 'text-success-a11',
      link: 'https://dashboard.scale.com/corp/genai-ops-hub/compass/playground?workflow=cmp_b15f8f8c6e593bc24b7c480a92399868',
    },
    {
      icon: faUserGraduate,
      label: 'User Graduate',
      workflowName: 'LLM evals on CB resumes',
      iconBackgroundColor: 'bg-accent-a2',
      iconColor: 'text-accent-a11',
      link: 'https://dashboard.scale.com/corp/genai-ops-hub/compass/playground?workflow=cmp_29029380054f4f533ece387d5647f332',
    },
    {
      icon: faBan,
      label: 'Auto-disable',
      workflowName: 'Auto-disable CBs who fail review wall',
      iconBackgroundColor: 'bg-error-a2',
      iconColor: 'text-error-a11',
      link: 'https://dashboard.scale.com/corp/genai-ops-hub/compass/playground?workflow=cmp_42de592c9a886dced422444ca4501a46',
    },
    {
      icon: faCheckCircle,
      label: 'Auto-promote',
      workflowName: 'Auto-promote CBs who passed quiz',
      iconBackgroundColor: 'bg-success-a2',
      iconColor: 'text-success-a11',
      link: 'https://dashboard.scale.com/corp/genai-ops-hub/compass/playground?workflow=cmp_828b3db2daa31afab06adf7b9ffb93f0',
    },
    {
      icon: faBolt,
      label: 'Bulk explain',
      workflowName: 'Bulk explain queue to save time',
      iconBackgroundColor: 'bg-warning-a2',
      iconColor: 'text-warning-a11',
      link: 'https://dashboard.scale.com/corp/genai-ops-hub/compass/playground?workflow=cmp_915ac3c8ca899f9ab8f6ebf3e12c417c',
    },
    {
      icon: faTags,
      label: 'Categorize',
      workflowName: 'Categorize tasks & update metadata',
      iconBackgroundColor: 'bg-accent-a2',
      iconColor: 'text-accent-a11',
      link: 'https://dashboard.scale.com/corp/genai-ops-hub/compass/playground?workflow=cmp_0e1955fe67b3f988059ee29d89f644db',
    },
    {
      icon: faFileAlt,
      label: 'QC Feedback',
      workflowName: 'Match QC feedback to rubric',
      iconBackgroundColor: 'bg-info-a2',
      iconColor: 'text-info-a11',
      link: 'https://dashboard.scale.com/corp/genai-ops-hub/compass/playground?workflow=cmp_1c962d1304d246c4c14aecd3f614682f',
    },
  ],
  debugCommandTpl: [
    `cd ~/scaleapi/server &&`,
    `yarn script-prod-ro scripts/compass/run_transformer.ts`,
    `\t--dataFile={{dataFile}}`,
    `\t--cardContext="$(echo '{{cardContext}}' | base64 -d)"`,
  ].join(' \\\n'),
});
